import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { MatterType } from '../../../models/matter-type';

import { AlertService } from '../../../services/common/alert.service';
import { MatterTypeService } from '../../../services/matters/matter-type.service';

@Component({
  selector: 'app-matter-type-form',
  templateUrl: './matter-type-form.component.html',
  styleUrls: ['./matter-type-form.component.css'],
})
export class MatterTypeFormComponent implements OnInit {
  @Input() matterType: MatterType = new MatterType();

  formOptions: any = {
    activities: [],
  };

  formSubmitting: boolean = false;
  formSubmitted: boolean = false;

  constructor(private matterTypeService: MatterTypeService, private router: Router, private alertService: AlertService) {
    this.matterTypeService.getFormOptions().then((response_json) => (this.formOptions = response_json));
  }

  ngOnInit() {}

  submitForm(formValid: any) {
    this.formSubmitted = true;
    if (formValid) {
      this.formSubmitting = true;
      if (this.matterType.id)
        this.matterTypeService
          .updateMatterType(this.matterType.id, this.matterType)
          .then((response_json) => {
            this.formSubmitting = false;
            if (response_json && response_json.text) {
              this.alertService.alert_status_success(response_json.text);
              this.router.navigate(['/matter_types']);
            } else this.alertService.alert_status_danger('Error updating matter type');
          })
          .catch(() => {
            this.formSubmitting = false;
            this.alertService.alert_status_danger('Error updating matter type');
          });
      else
        this.matterTypeService
          .createMatterType(this.matterType)
          .then((response_json) => {
            this.formSubmitting = false;
            if (response_json && response_json.text) {
              this.alertService.alert_status_success(response_json.text);
              this.router.navigate(['/matter_types']);
            } else this.alertService.alert_status_danger('Error creating matter type');
          })
          .catch(() => {
            this.formSubmitting = false;
            this.alertService.alert_status_danger('Error creating matter type');
          });
    }
  }

  fieldShowErrorMessage(field: any) {
    if (!field.valid && this.formSubmitted) return true;
    else return false;
  }
}
